import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/user/aiboosted-website/layouts/default.vue").then(m => m.default || m))
}